import { Paragraph } from 'components';
import styled from 'styled-components';

export const CustomParagraph = styled(Paragraph)`
  margin-top: 24px;
  margin-bottom: 16px;
`;
